import type { EventSummary, StreamHealth } from '@/types/admin';

export type GroupedStreams = {
  orgId: string | null;
  orgName: string;
  events: {
    eventId: string | null;
    eventName: string;
    streams: StreamHealth[];
  }[];
}[];

type OrgGroup = {
  orgId: string | null;
  orgName: string;
  eventMap: Map<string, { eventId: string | null; eventName: string; streams: StreamHealth[] }>;
};

export function groupStreamsByOrgAndEvent(
  streams: StreamHealth[],
  events: EventSummary[] = []
): GroupedStreams {
  const eventById = new Map(events.map((event) => [event.id, event]));
  const orgMap = new Map<string, OrgGroup>();

  for (const stream of streams) {
    const event = stream.event_id ? eventById.get(stream.event_id) : undefined;
    const orgId = event?.organization_id ?? null;
    const orgName = event?.organization_name ?? stream.organization_name ?? 'No organization';
    const orgKey = orgId ? `org:${orgId}` : `name:${orgName}`;

    if (!orgMap.has(orgKey)) {
      orgMap.set(orgKey, {
        orgId,
        orgName,
        eventMap: new Map(),
      });
    }

    const org = orgMap.get(orgKey)!;
    const eventId = stream.event_id ?? null;
    const eventName = event?.name ?? stream.event_name ?? 'No event';
    const eventKey = eventId ? `event:${eventId}` : `name:${eventName}`;

    if (!org.eventMap.has(eventKey)) {
      org.eventMap.set(eventKey, {
        eventId,
        eventName,
        streams: [],
      });
    }

    org.eventMap.get(eventKey)!.streams.push(stream);
  }

  return Array.from(orgMap.values()).map(({ orgId, orgName, eventMap }) => ({
    orgId,
    orgName,
    events: Array.from(eventMap.values()),
  }));
}
